export interface Speaker {
  name: string,
  company: string,
  position?: string,
  zoomLink?: string,
  calendlyLink?: string,
  image?: string,
  email?: string,
  description?: string,
  id?: string,
  category?: string,
  linkedin?: string
}

export const speakers: Speaker[] = [
  {
    category: "JURY",
    name: "Dominik Zalewski",
    company: "Urban Impact",
    position: "Co-founder",
    linkedin: "https://www.linkedin.com/in/dominik-zalewski-84782546/",
    image: '../../../assets/images/speakers/Dominik_Zalewski.jpg',
    calendlyLink: "https://calendly.com/zalewski/meeting"
  },
  {
    category: "JURY",
    name: "Oksana Prykhodko",
    company: "DTEK",
    position: "Innovation Manager",
    linkedin: "https://www.linkedin.com/in/oksana-prykhodko-01a336182/",
    image: '../../../assets/images/speakers/Oksana_Prykhodko.jpg',
    calendlyLink: "https://calendly.com/prykhodko-1/meeting"
  },
  {
    category: "JURY",
    name: "Marzena Bielecka",
    company: "Experior Venture Fund",
    position: "Managing Partner ",
    linkedin: "https://www.linkedin.com/in/marzena-bielecka-811a8a3/",
    image: '../../../assets/images/speakers/Marzena_Bielecka.jpg',
    calendlyLink: "https://calendly.com/bielecka/meeting"
  },
  {
    category: "JURY",
    name: "Jennifer Dungs",
    company: "EIT InnoEnergy",
    position: "Lead for Transport and Mobility",
    linkedin: "https://www.linkedin.com/in/jennyejacobs/",
    image: '../../../assets/images/speakers/Jennifer_Dungs.jpg',
    calendlyLink: "https://calendly.com/dungs/meeting"
  },
  {
    category: "Keynote",
    name: "Lech Kaniuk",
    company: "SunRoof International Holding AB",
    position: "CEO",
    linkedin: "https://www.linkedin.com/in/lech-kaniuk/",
    image: '../../../assets/images/speakers/Lech-Kaniuk-.jpg',
    calendlyLink: "https://calendly.com/kaniuk/meeting"
  },
  {
    category: "PowerUp! Finallist",
    name: "Olena Sydorenko",
    company: "GreenBin ",
    position: "",
    linkedin: "",
    image: '../../../assets/images/speakers/Speaker2.jpg',
    calendlyLink: "https://calendly.com/sydorenko-1/meeting"
  },
  {
    category: "PowerUp! Finallist",
    name: "Donat Ponamariov",
    company: "Viezo ",
    position: "",
    linkedin: "https://www.linkedin.com/in/donat-ponamariov-638840a0/",
    image: '../../../assets/images/speakers/Donat-Ponamariov.jpg',
    calendlyLink: "https://calendly.com/ponamariov/meeting"
  },
  {
    category: "PowerUp! Finallist",
    name: "Daniel Pintilie",
    company: "Watto ",
    position: "",
    linkedin: "https://www.linkedin.com/in/danielpintilie/",
    image: '../../../assets/images/speakers/Speaker3.jpg',
    calendlyLink: "https://calendly.com/pintilie/meeting"
  },
  {
    category: "PowerUp! Finallist",
    name: "Kristians Grundstuks",
    company: "Polylabs",
    position: "",
    linkedin: "https://www.linkedin.com/in/kristians-grundstoks-27b095a2/",
    image: '../../../assets/images/speakers/Kristians_Grundstoks.jpg',
    calendlyLink: "https://calendly.com/grundstuks/meeting"
  },
  {
    category: "PowerUp! Finallist",
    name: "Mustafa Kemal İşen",
    company: "Blink Energy",
    position: "",
    linkedin: "https://www.linkedin.com/in/mustafa-kemal-i%C5%9Fen-16048535/",
    image: '../../../assets/images/speakers/Mustafa-Kemal-Isen.jpg',
    calendlyLink: "https://calendly.com/mustafa-28/meeting"
  },
  {
    category: "PowerUp! Finallist",
    name: "Matjaž Breznik",
    company: "Troia",
    position: "",
    linkedin: "https://www.linkedin.com/in/geomsp/",
    image: '../../../assets/images/speakers/Matjaz-Breznik.jpg',
    calendlyLink: "https://calendly.com/breznik/meeting"
  },
  {
    category: "PowerUp! Finallist",
    name: "Anna-Liisa Palatu",
    company: "Woola  ",
    position: "",
    linkedin: "https://www.linkedin.com/in/annaliisapalatu/",
    image: '../../../assets/images/speakers/Anna-Liisa-Palatu.jpg',
    calendlyLink: "https://calendly.com/palatu-1/meeting"
  },
  {
    category: "PowerUp! Finallist",
    name: "Duje Roje",
    company: "Eazy Oil ",
    position: "",
    linkedin: "https://www.linkedin.com/in/duje-roje-4b41a974/",
    image: '../../../assets/images/speakers/Duje_Roje.jpg',
    calendlyLink: "https://calendly.com/roje/meeting"
  },
  {
    category: "PowerUp! Finallist",
    name: "Liz Madaras",
    company: "Poliloop ",
    position: "",
    linkedin: "https://www.linkedin.com/in/liz-madaras/",
    image: '../../../assets/images/speakers/Liz-Madaras.jpg',
    calendlyLink: "https://calendly.com/madaras/meeting"
  },
  {
    category: "PowerUp! Finallist",
    name: "Lucie Brešová",
    company: "Pocket Virtuality ",
    position: "",
    linkedin: "https://www.linkedin.com/in/luciebresova/",
    image: '../../../assets/images/speakers/Lucie_Bresova.jpg',
    calendlyLink: "https://calendly.com/bresova/meeting"
  },
  {
    category: "PowerUp! Finallist",
    name: "Petar Zhivkov",
    company: "Airlief",
    position: "",
    linkedin: "https://www.linkedin.com/in/petarzhivkov/",
    image: '../../../assets/images/speakers/speaker1.jpg',
    calendlyLink: "https://calendly.com/zhivkov/meeting"
  },
  {
    category: "PowerUp! Finallist",
    name: "Aleksandar Kavgic",
    company: "TyphoonHill",
    position: "",
    linkedin: "https://www.linkedin.com/in/aleksandar-kavgic-49bb07128/",
    image: '../../../assets/images/speakers/Speakre4.jpg',
    calendlyLink: "https://calendly.com/kavgic/meeting"
  },
  {
    category: "PowerUp! Finallist",
    name: "Vasilis Stenos",
    company: "Solmeyea ",
    position: "",
    linkedin: "https://www.linkedin.com/in/vasilisstenos/",
    image: '../../../assets/images/speakers/Vasilis-Stenos.jpg',
    calendlyLink: "https://calendly.com/stenos/meeting"
  },
  {
    category: "PowerUp! Finallist",
    name: "Pavol Magic",
    company: "Biotron Labs",
    position: "",
    linkedin: "https://www.linkedin.com/in/pavolmagic/",
    image: '../../../assets/images/speakers/pavol-magic.jpg',
    calendlyLink: "https://calendly.com/magic-6/meeting"
  },
  {
    category: "EIT InnoEnergy",
    name: "Szymon Kwiatkowski",
    company: "EIT InnoEnergy",
    position: "Investment Manager",
    linkedin: "https://www.linkedin.com/in/szymon-kwiatkowski-cfa-7165a613/",
    image: '../../../assets/images/speakers/Szymon-Kwiatkowski.jpg',
    calendlyLink: "https://calendly.com/kwiatkowski-1/meeting"
  },
  {
    category: "EIT InnoEnergy",
    name: "Michał Bajda",
    company: "EIT InnoEnergy",
    position: "Investment Manager",
    linkedin: "https://www.linkedin.com/in/micha%C5%82-bajda-07b24611a/",
    image: '../../../assets/images/speakers/Michal_Bajda.jpg',
    calendlyLink: "https://calendly.com/bajda/meeting"
  },
  {
    category: "EIT InnoEnergy",
    name: "Maciej Majchrowicz",
    company: "EIT InnoEnergy",
    position: "Investment Manager",
    linkedin: "https://www.linkedin.com/in/majchrowiczmaciej/",
    image: '../../../assets/images/speakers/Maciej_Majchrowicz.jpg',
    calendlyLink: "https://calendly.com/majchrowicz/meeting"
  },
  {
    category: "EIT InnoEnergy",
    name: "Grzegorz Opach",
    company: "EIT InnoEnergy",
    position: "Business Development Director CEE",
    linkedin: "https://www.linkedin.com/in/grzegorzopach/",
    image: '../../../assets/images/speakers/Grzegorz-Opach.jpg',
    calendlyLink: "https://calendly.com/opach/meeting"
  },{
    category: "EIT InnoEnergy Supported Asset",
    name: "Marcin Koziorowski",
    company: "EcoBean",
    position: "CEO & Co-Founder",
    linkedin: "https://www.linkedin.com/in/marcin-koziorowski/",
    // image: '../../../assets/images/speakers/Marcin_Koziorowski.jpg',
    image: '../../../assets/images/speakers/Marcin_Koziorowski.jpg',
    
    calendlyLink: "https://calendly.com/koziorowski/meeting"
  },
  {
    category: "EIT InnoEnergy Supported Asset",
    name: "Henri Klemmer",
    company: "Hepta Airborne",
    position: "Co-Founder & CEO",
    linkedin: "https://www.linkedin.com/in/henriklemmer/",
    image: '../../../assets/images/speakers/Henri-Klemmer.jpg',
    calendlyLink: "https://calendly.com/klemmer/meeting"
  },
  {
    category: "EIT InnoEnergy Supported Asset",
    name: "Matuesz Młodawski",
    company: "WheelMe",
    position: "CEO & Co-Founder",
    linkedin: "https://www.linkedin.com/in/mmlodawski/",
    image: '../../../assets/images/speakers/Mateusz_Mlodawski.jpg',
    calendlyLink: "https://calendly.com/mlodawski/meeting"
  },
  {
    category: "EIT InnoEnergy Supported Asset",
    name: "Thomas Bräck",
    company: "Meva Energy",
    position: "Business Development Director",
    linkedin: "https://www.linkedin.com/in/thomas-br%C3%A4ck/",
    image: '../../../assets/images/speakers/Thomas-Brack.jpg',
    calendlyLink: "https://calendly.com/brack-1/meeting"
  },
  {
    category: "EIT InnoEnergy Supported Asset",
    name: "Mislav Javor",
    company: "AMPNet",
    position: "CEO",
    linkedin: "https://www.linkedin.com/in/mislavjavor/",
    image: '../../../assets/images/speakers/MislavJavor.jpg',
    calendlyLink: "https://calendly.com/javor/meeting"
  },
  {
    category: "EIT InnoEnergy Supported Asset",
    name: "Mihai Darzan",
    company: "Ringhel",
    position: "International Business Development Manager",
    linkedin: "https://www.linkedin.com/in/darzan-mihai-b8621420/",
    image: '../../../assets/images/speakers/Mihai-DARZAN.jpg',
    calendlyLink: "https://calendly.com/darzan/meeting"
  }
 ]
